module.exports = __webpack_public_path__ + "img/DEM_White_PNG.ce5a514d.png";